if (!customElements.get('countdown-timer')) {
	class Countdown extends HTMLElement {
		constructor() {
			super()
			this.userDate = this.getAttribute('data-date')
			this.userTime = this.getAttribute('data-time')
			this.mockTimer = this.getAttribute('data-mock-timer')

			// AUTO-CALCULATE NEXT SATURDAY 23:59 (if no date/time provided)
			if (!this.userDate || !this.userTime || this.userDate === '' || this.userTime === '') {
				const nextSaturday = this.getNextSaturday()
				this.userDate = nextSaturday.date
				this.userTime = nextSaturday.time
			}

			// Mock timer for testing (adds 2 days)
			if (this.mockTimer === 'true') {
				const d = new Date()
				d.setDate(d.getDate() + 2)
				const year = d.getFullYear()
				const m = d.getMonth() + 1
				const month = m < 10 ? '0' + m : m
				const day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
				const h = d.getHours() < 15 ? d.getHours() + 3 : d.getHours() - 3
				const hourss = h < 10 ? '0' + h : h
				const minutess =
					d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
				this.userDate = year + '-' + month + '-' + day
				this.userTime = hourss + ':' + minutess
			}

			this.interval
			this.setInterval(this.userDate, this.userTime)
		}

		// NEW METHOD: Calculate next Saturday at 23:59
		getNextSaturday() {
			const now = new Date()
			const currentDay = now.getDay() // 0 = Sunday, 6 = Saturday
			const currentHour = now.getHours()
			const currentMinute = now.getMinutes()
			
			let daysUntilSaturday = 6 - currentDay // Days until Saturday
			
			// If it's Saturday and before 23:59, use today
			if (currentDay === 6 && (currentHour < 23 || (currentHour === 23 && currentMinute < 59))) {
				daysUntilSaturday = 0
			}
			// If it's Saturday after 23:59 or Sunday, go to next Saturday
			else if (currentDay === 6 || currentDay === 0) {
				daysUntilSaturday = currentDay === 6 ? 7 : 6
			}
			
			// Calculate the target date
			const targetDate = new Date(now)
			targetDate.setDate(now.getDate() + daysUntilSaturday)
			
			// Format date as YYYY-MM-DD
			const year = targetDate.getFullYear()
			const month = String(targetDate.getMonth() + 1).padStart(2, '0')
			const day = String(targetDate.getDate()).padStart(2, '0')
			
			return {
				date: `${year}-${month}-${day}`,
				time: '23:59'
			}
		}

		onInit(userDate, userTime) {
			this.completedCountdown = this.getAttribute('data-completed')
			this.countdown = this.querySelector('.countdown__main')
			this.countdownHeading = this.querySelector('.countdown__end-info')
			this.daysEl = this.querySelector('.countdown_block_days')
			this.hoursEl = this.querySelector('.countdown_block_hours')
			this.minutesEl = this.querySelector('.countdown_block_minutes')
			this.secondsEl = this.querySelector('.countdown_block_seconds')
			this.section = this.closest('.countdown-section')
			
			// Check if we have valid date/time, if not use automatic Saturday
			if (!userDate || !userTime || userDate === '' || userTime === '') {
				const nextSaturday = this.getNextSaturday()
				userDate = nextSaturday.date
				userTime = nextSaturday.time
			}
			
			// ----------------------------------------------------------------
			const countdownDate = new Date(`${userDate}T${userTime}`)
			const now = new Date()
			const distance = countdownDate.getTime() - now.getTime()
			const days = Math.floor(distance / (1000 * 60 * 60 * 24))
			const hours = Math.floor(
				(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
			)
			const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
			const seconds = Math.floor((distance % (1000 * 60)) / 1000)
			// ----------------------------------------------------------------
			if (distance < 0 && this.completedCountdown === 'hide_section') {
				clearInterval(this.interval)
				this.section.style.display = 'none'
				// AUTO-RESTART: Calculate next Saturday and restart timer
				const nextSaturday = this.getNextSaturday()
				setTimeout(() => {
					this.userDate = nextSaturday.date
					this.userTime = nextSaturday.time
					this.section.style.display = ''
					this.countdown.style.display = ''
					this.setInterval(this.userDate, this.userTime)
				}, 1000)
			} else if (distance < 0 && this.completedCountdown === 'show_text') {
				this.countdown.style.display = 'none'
				this.countdownHeading.style.display = 'flex'
				// AUTO-RESTART: Calculate next Saturday and restart timer
				const nextSaturday = this.getNextSaturday()
				setTimeout(() => {
					this.userDate = nextSaturday.date
					this.userTime = nextSaturday.time
					this.countdown.style.display = ''
					this.countdownHeading.style.display = 'none'
					this.setInterval(this.userDate, this.userTime)
				}, 1000)
			} else {
				// Make numbers visible on first calculation
				this.daysEl.style.visibility = 'visible'
				this.hoursEl.style.visibility = 'visible'
				this.minutesEl.style.visibility = 'visible'
				this.secondsEl.style.visibility = 'visible'
				
				// Fade in the entire countdown
				this.style.opacity = '1'
				
				if (String(days).length === 1) this.daysEl.textContent = '0' + days
				else this.daysEl.textContent = days

				if (String(hours).length === 1) this.hoursEl.textContent = '0' + hours
				else this.hoursEl.textContent = hours

				if (String(minutes).length === 1)
					this.minutesEl.textContent = '0' + minutes
				else this.minutesEl.textContent = minutes

				if (String(seconds).length === 1)
					this.secondsEl.textContent = '0' + seconds
				else this.secondsEl.textContent = seconds
			}
		}

		setInterval(userDate, userTime) {
			clearInterval(this.interval)
			this.interval = setInterval(
				this.onInit.bind(this, userDate, userTime),
				1000
			)
		}
	}

	customElements.define('countdown-timer', Countdown)
}